const VersionRange = {
  type: 'string',
  pattern: '^(\\d+)(\\.\\d+)*(\\.x)*$|^x(\\.x)*$',
};

export default VersionRange;
